import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');

    if (!sessionId) {
      navigate('/');
      return;
    }

    const exchangeSession = async () => {
      try {
        const res = await axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true });
        // Store token for reliable single sign-in
        if (res.data.session_token) {
          sessionStorage.setItem('session_token', res.data.session_token);
        }
        sessionStorage.setItem('user_data', JSON.stringify(res.data));
        setUser(res.data);
        navigate('/dashboard', { state: { user: res.data }, replace: true });
      } catch (err) {
        console.error('Auth failed:', err);
        navigate('/');
      }
    };

    exchangeSession();
  }, [navigate, setUser]);

  return null;
}
